import React from 'react';
import Header from '../common/Header';
import Footer from '../common/Footer';
import { Link } from 'react-router-dom';

const ContestRules = () => {
  return (
    <div>
      <Header />
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/" className="inline-block mb-6 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
          Back to Contest
        </Link>

        <h1 className="text-3xl font-bold mb-6">Official Contest Rules: Revolution Travel Free Cruise Giveaway</h1>
        
        <div className="prose prose-lg">
          <p><strong>NO PURCHASE NECESSARY TO ENTER OR WIN. A PURCHASE WILL NOT INCREASE YOUR CHANCES OF WINNING. VOID WHERE PROHIBITED BY LAW.</strong></p>

          <h2 className="text-xl font-semibold mt-6 mb-4">1. Contest Period</h2>
          <p>
            The contest begins on December 30, 2024, at 12:00 AM (EST) and ends on November 2, 2025, at 11:59 PM (EST).
            The draw will be conducted on November 9, 2025, and the winner will be notified by November 16, 2025, or within two weeks of the contest closing.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">2. Eligibility</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>Open to legal residents of Canada, excluding residents of Quebec, aged 18 or older as of the date or registration.</li>
            <li>Participants must be legally eligible for travel to the United States and other nations of the Caribbean.</li>
            <li>
              Participants may only enter once, verified by matching Name, Date of Birth, Address, and Email. Information must match a valid government-issued photo ID to claim the prize.
            </li>
            <li>Gaming the system is strictly prohibited. Participants found creating multiple profiles or using fraudulent methods will have all entries disqualified.</li>
            <li>Employees, agents, and representatives of Revolution Travel, and their immediate family members, are not eligible to participate.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-4">3. How to Enter</h2>
          <p>Participants may earn entries through free activities or purchases.</p>
          <h3 className="text-lg font-semibold mt-4 mb-2">A. Weekly Activities (Free Entry Methods):</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Specific ways to earn weekly entries will be updated closer to the contest launch.</li>
            <li>Odds of being selected as a Weekly Finalist are proportional to the number of entries earned during that week.</li>
          </ul>
          <h3 className="text-lg font-semibold mt-4 mb-2">B. Monthly and Yearly Entries:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <strong>Monthly Finalists:</strong> Drawn twice per month from all entries earned during that month, with odds proportional to the number of entries earned.
            </li>
            <li>
              <strong>Yearly Finalists:</strong> Drawn at the end of the contest from all entries earned throughout the contest, with odds proportional to the number of entries earned.
            </li>
          </ul>
          <h3 className="text-lg font-semibold mt-4 mb-2">C. Purchase-Based Entries:</h3>
          <ul className="list-disc pl-5 space-y-2">
            <li>Purchases are separate from free methods of entry:</li>
            <li>Earn 1 entry per $100 spent* on any travel product (gross, rounded down).</li>
            <li>Earn 5 entries per $100 spent* on Virgin Voyages bookings (gross, rounded down).</li>
            <li>Purchases are tracked by the lead guest's name and verified via the client list (CL) reports.</li>
          </ul>
          <p className="mt-4 text-sm">
            *Both figures are rounded down to the nearest $100. For example, a purchase of $349 earns 3 entries, and a purchase of $75 earns 1 entry.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">4. Prize Details</h2>
          <p>The Grand Prize includes:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>
              A 5-day Virgin Voyages cruise aboard Scarlet Lady for the Fire & Sunset Soirées departing on December 10, 2025, for two guests in a balcony stateroom.
            </li>
          </ul>
          <p>The winner is responsible for the following:</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>All taxes and fees totaling CAD $632.38</li>
            <li>Transportation to and from Miami, Florida (the embarkation port)</li>
            <li>Gratuities, personal expenses, and optional onboard purchases</li>
            <li>Additional expenses in the event of delays or itinerary changes</li>
            <li>Additional expenses such as excursions, beverages, transfers, alcohol, upgrades, and other optional enhancements</li>
            <li>Answer a skill-testing question as required by law</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-4">5. General Conditions</h2>
          <ul className="list-disc pl-5 space-y-2">
            <li>The prize must be accepted as awarded; substitutions, transfers, or cash redemptions are not allowed.</li>
            <li>The winner and their guest must travel together on all segments of the trip.</li>
            <li>It is the sole responsibility of the winner to obtain all necessary travel documentation, including passports and visas, and to comply with immigration requirements.</li>
            <li>All personal data collected will comply with Canadian privacy laws (PIPEDA).</li>
            <li>The prize winner will be informed by email, and their name and personal details may be used in future promotions associated with the organizer and the promoter.</li>
            <li>Revolution Travel nor any other person or party associated with this promotion shall be liable for any loss or damage suffered (including but not limited to indirect or consequential loss or damage) or personal injury suffered or sustained in connection with either participation in this promotion or with any prizes offered.</li>
            <li>The winner will be required to sign a release of liability and indemnity agreement.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6 mb-4">6. Disclaimer</h2>
          <p>
            This contest is in no way sponsored, endorsed, administered by, or associated with Virgin Voyages. All references to Virgin Voyages are for prize description purposes only. Revolution Travel assumes full responsibility for the administration of this contest.
          </p>
          <p>
            Revolution Travel assumes no responsibility for errors, omissions, interruptions, or issues related to the promotion or prize redemption.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-4">7. Publicity</h2>
          <p>
            By entering, participants agree to allow Revolution Travel to use their first name, last name, and photo for promotional purposes without additional compensation.
          </p>
        </div>

        <Link to="/" className="inline-block mt-8 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
          Back to Contest
        </Link>
      </div>
      <Footer />
    </div>
  );
};

export default ContestRules;
